import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";
import { ADMIN_RESOURCE_TYPES } from "../constants";

interface ResourceTypeSelectProps {
  value?: string;
  onChange: (resourceType: string) => void;
  placeholder?: string;
  /** When provided, restrict the options to these resource types. */
  allowedTypes?: string[];
  disabled?: boolean;
}

/** A dropdown of the FHIR resource types the Admin panel supports. */
export const ResourceTypeSelect = ({
  value,
  onChange,
  placeholder = "Select resource type",
  allowedTypes,
  disabled,
}: ResourceTypeSelectProps) => {
  const options = allowedTypes
    ? ADMIN_RESOURCE_TYPES.filter((resource) =>
        allowedTypes.includes(resource.type),
      )
    : ADMIN_RESOURCE_TYPES;

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((resource) => (
          <SelectItem key={resource.type} value={resource.type}>
            {resource.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
